import { build } from './methods/build'
import { createPattern } from './methods/create-pattern'
import { matchesPrefix } from './methods/matches-prefix'
import { parseKey } from './methods/parse-key'

/**
 * Key oluşturucu servis
 * Redis benzeri dinamik key oluşturma mantığı
 */
export const keyBuilderService = {
  build,
  createPattern,
  matchesPrefix,
  parseKey
}

export {
  build,
  createPattern,
  matchesPrefix,
  parseKey
}